import React, { Component } from 'react';
import logo from '../logo.svg';
import css from './header.scss';

class Header extends Component {
	render() {
		return (
			<header className={css.header}>
				<img src={logo} className={css.logo} alt="Solar Management" />
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/header/header.js